import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { global_var } from '../../services/cs-lab-config';
import IdeHeader from "./ide-header";
import { Spin, message } from "antd";
import { v4 as uuidv4 } from 'uuid';
import { createIdeProject, getIdeProjectDetails, updateIdeProject } from "../../services/ide-apis";
import {  trackEvent } from "../utils/util-functions";

const ScratchJrIde = () => {
    let {
        ideProjectId
    } = useParams();
    let [selectedProjectId, setProjectId] = useState(undefined);
    let [vc2Ready, setvc2Ready] = useState(false);
    let [ideProjectDetails, setIdeProjectDetails] = useState(undefined);
    // let [submittedForEvaluation, setSubmittedForEvaluation] = useState(false);
    // const [evaluationStatus, setEvaluationStatus] = useState(undefined);
    let [mode, setProjectMode] = useState('newProject');
    document.title = "CS Lab | Scratch Jr IDE";

    useEffect(() => {
        const handler = (event) => {
            let data = event.data;
            if (data.status === 'vc2-ready') {
              setvc2Ready(true);
              const scratchWindow = document.getElementById('scratchJrFrame').contentWindow;
              let postMsg = {
                  status: 'fromIde',
                  companyId: global_var.company_id,
                  crmId: global_var.roleMappingId,
                  independentProject: true,
                  fkUserLoginId: global_var.user_login_id,
                  pathToSave: 'IDEFiles/' + global_var.user_login_id + '/' + uuidv4(),
              };
              scratchWindow.postMessage(postMsg, '*');
            } else if (data.status === 'fileSaved') {
                function saveProject(projectName, fileS3reference, thumbnail, uniqueFileId, replaceFile) {
                    if (!selectedProjectId) {
                        trackEvent("new_project_create_button_clicked",{ide_project_stack_name: "scratchjr"})
                        let ideProjectData = {
                            "isFile": true,
                            "projectLanguage": 'scratchjr',
                            "fileS3reference": fileS3reference,
                            'thumbnail': thumbnail,
                            'uniqueFileId': uniqueFileId
                        }

                        createIdeProject(projectName, 'scratchjr', ideProjectData).then((response) => {
                            response = response.data
                            if (response.statusCode === 200) {
                                setProjectId(response.ideProjectId);
                                setProjectMode('editProject')
                                message.open({
                                    type: 'success',
                                    content: 'Project created successfully',
                                });
                            } else {
                                message.open({
                                    type: 'error',
                                    content: response.message,
                                });
                            }
                        });
                    } else if(replaceFile){
                      let updateObj = {
                        "fileS3reference": fileS3reference,
                        'thumbnail': thumbnail,
                        'uniqueFileId': uniqueFileId
                      }

                      updateIdeProject(selectedProjectId, updateObj)
                      trackEvent("ide_save_button_clicked",{ide_project_stack_name: "scratchjr"})

                    }
                    else {
                        trackEvent("ide_save_button_clicked",{ide_project_stack_name: "scratchjr"})
                        message.open({
                            type: 'success',
                            content: 'Project saved successfully',
                        });
                    }

                }
                saveProject(data['projectName'], data['value'], data['thumbnail'], data['uniqueFileId'], data['replaceFile']);
            }
        }

        window.addEventListener('message', handler);


        if (ideProjectId) {
            setProjectMode('editProject');
            setProjectId(ideProjectId);
        }
        return () => {
            window.removeEventListener('message', handler);
        };
    }, [ideProjectId, selectedProjectId])

    useEffect(() => {
      function loadFile(){
        let postMsg = {
            status: 'loadFile',
            companyId: global_var.company_id,
            crmId: global_var.roleMappingId,
            independentProject: true,
            uniqueFileId: ideProjectDetails['uniqueFileId'],
            viewOnly: false,
            projectName: ideProjectDetails['name']
        };
        if((global_var.user_login_id !== ideProjectDetails.fkUserLoginId )|| (ideProjectDetails.evaluationStatus? ideProjectDetails.evaluationStatus === 'Evaluated': false)) {
          postMsg.viewOnly = true;
        }
  
        postMsg['value'] = ideProjectDetails['fileS3reference'];
        var pathArray = ideProjectDetails['fileS3reference'].split("/");
        pathArray.splice((pathArray.length - 1), 1);
        postMsg['pathToSave'] = pathArray.join("/").replace("files/", "");
        
        const scratchWindow = document.getElementById('scratchJrFrame').contentWindow;
          scratchWindow.postMessage(postMsg, '*');
      }

      if(ideProjectDetails){
        if(ideProjectDetails){
          loadFile();
        }
      }
    }, [ideProjectDetails, vc2Ready]);

    useEffect(() => {
        if (selectedProjectId) {
            getIdeProjectDetails(selectedProjectId).then((response) => {
                response = response.data;

                if (response.statusCode === 200) {
                    if ( response.projectDetails.fkUserLoginId === global_var.user_login_id || global_var.role_id !== global_var.STUDENT_ROLE_ID) {
                        setIdeProjectDetails(response.projectDetails);

                        // setSubmittedForEvaluation(
                        //   response.projectDetails.submittedForEvaluation
                        // );

                        // setEvaluationStatus(response.projectDetails.evaluationStatus);
                    } else {
                        message.error("Your session expired. Please login again");
                    }
                } else {
                    message.error(response.message);
                }
            });
        }
    }, [selectedProjectId, mode]);

    const [isLoading, setShowSpinner] = useState(true); // State to track loading status 
    const iframeUrl = global_var.SCRATCHJR_ENDPOINT

    const handleIframeLoad = () => {
        setShowSpinner(false); // Set loading status to false when iframe content is loaded
    };

    // function handleEvaluateClicked() {
    //     let evaluationStatusToUpdate;
    //     let teacherRemark;
    //     Modal.info({
    //       title: "Evaluate Project " + ideProjectDetails.name,
    //       icon: null,
    //       width: 500,
    //       closable: true,
    //       content: (
    //         <>
    //           <Select
    //             onChange={(selectedValue) =>
    //               (evaluationStatusToUpdate = selectedValue)
    //             }
    //             placeholder="Please select a status"
    //             className="mb-2"
    //             style={{ width: "100%" }}
    //             options={[
    //               { value: "Evaluated", label: "Evaluated" },
    //               { value: "Ask for resubmission", label: "Ask for resubmission" },
    //               { value: "Pending evaluation", label: "Pending evaluation" },
    //             ]}
    //           />
    //           <Input.TextArea
    //             onChange={(e) => (teacherRemark = e.target.value)}
    //             rows={4}
    //             placeholder="Please enter your remarks"
    //           />
    //         </>
    //       ),
    //       onOk: () => {
    //         if (!evaluationStatusToUpdate) {
    //           return;
    //         }
    //         trackEvent("ide_evaluate_project_ok_clicked", {
    //           ide_project_stack_name: "scratchjr",
    //           ide_evaluation_status: evaluationStatusToUpdate,
    //         });
    
    //         saveIdeProjectEvaluation(
    //           ideProjectDetails._id,
    //           evaluationStatusToUpdate,
    //           teacherRemark
    //         ).then((response) => {
    //           response = response.data;
    //           if (response.statusCode === 200) {
    //             message.success(response.message);
    //             setEvaluationStatus(evaluationStatusToUpdate);
    //           } else {
    //             message.error(response.message);
    //           }
    //         });
    //       },
    //     });
    // }

    return (
        <div className="container-fluid p-0">
            <div className="row">
                <div className="col">
                    <IdeHeader
                        headerName="Visual coding Jr IDE"
                        // setSubmittedForEvaluation={setSubmittedForEvaluation}
                        ideProjectDetails={ideProjectDetails}
                        submittedForEvaluation={ideProjectDetails? ideProjectDetails.submittedForEvaluation: false}
                        showInPortFolio={ideProjectDetails? ideProjectDetails.showInPortFolio: false}
                    />
                    {isLoading && <div
                        style={{
                            textAlign: "center",
                            marginTop: "10rem",
                        }}
                    >
                        <Spin />
                    </div> }

                    {/* Project details starts here */}
                    {/* {ideProjectDetails &&
                      !isLoading &&
                      global_var.role_id !== global_var.STUDENT_ROLE_ID &&
                      global_var.user_login_id !== ideProjectDetails.fkUserLoginId && (
                        <div className="row mt-3">
                          <div className="col">
                            <Space direction="vertical">
                              <Space wrap>
                                <span className="h5">{ideProjectDetails.name}</span>

                                {submittedForEvaluation && (
                                  <span
                                    className="badge fw-normal"
                                    style={{
                                      backgroundColor:
                                        getEvaluationStatusColor(evaluationStatus),
                                    }}
                                  >
                                    {getEvaluationStatusName(evaluationStatus)
                                      }
                                  </span>
                                )}
                              </Space>
                            </Space>

                            <Space direction="vertical" className="float-end">
                              <Space wrap>
                                {global_var.role_id !== global_var.STUDENT_ROLE_ID &&
                                  global_var.user_login_id !==
                                    ideProjectDetails.fkUserLoginId && (
                                    <Button
                                      type="primary"
                                      onClick={handleEvaluateClicked}
                                      size="small"
                                    >
                                      Evaluate
                                    </Button>
                                  )}
                              </Space>
                            </Space>
                          </div>
                        </div>
                      )} */}
                    {/* Project details ends here */}
                </div>
            </div>

            <div className="row">
              <div className="col">
                <iframe
                    id='scratchJrFrame'
                    src={iframeUrl}
                    title="Scratch JR"
                    allow='camera; microphone'
                    onLoad={handleIframeLoad} // Attach the load event handler
                    style={{
                        width: '100%',
                        overflow: 'auto',
                        minHeight: '800px'
                    }}
                ></iframe>
              </div>
            </div>
        </div>
    );
  };
export default ScratchJrIde;